import { Navigate, Route, Routes } from "react-router";

import { AppShell } from "@/components/app-shell";
import { AdminRoute, ProtectedRoute } from "@/components/protected-route";
import { AdminActivityPage } from "@/features/admin/activity";
import { AdminUsersPage } from "@/features/admin/users";
import { GuideOrderingPage, GuideOverviewPage, GuideSharePage, GuideShell } from "@/features/guide";
import { HomePage } from "@/features/home";
import { LoginPage } from "@/features/login";
import { NotFoundPage } from "@/features/not-found";
import { OrderingDetailPage, OrderingListPage } from "@/features/ordering";
import { ProfilePage } from "@/features/profile";
import { ShareDetailPage, ShareListPage } from "@/features/share";
import { VotePage } from "@/features/voting/vote-page";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="/login" element={<LoginPage />} />
      {/* Public, unauthenticated: attendees reach this by scanning the presenter's QR. */}
      <Route path="/vote" element={<VotePage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route path="/home" element={<HomePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/ordering" element={<OrderingListPage />} />
          <Route path="/ordering/:accountId" element={<OrderingDetailPage />} />
          <Route path="/share" element={<ShareListPage />} />
          <Route path="/share/:accountId" element={<ShareDetailPage />} />
          <Route path="/guide" element={<GuideShell />}>
            <Route index element={<GuideOverviewPage />} />
            <Route path="ordering" element={<GuideOrderingPage />} />
            <Route path="share" element={<GuideSharePage />} />
          </Route>
          <Route element={<AdminRoute />}>
            <Route path="/admin/users" element={<AdminUsersPage />} />
            <Route path="/admin/activity" element={<AdminActivityPage />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
